import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
// ...
import { api } from 'features/api/apiSlice'
import { queryApi } from 'features/queryApi/queryApiSlice'
import assessmentsReducer from 'features/assessments/assessmentsSlice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [queryApi.reducerPath]: queryApi.reducer,
    assessments: assessmentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([api.middleware]).concat([queryApi.middleware]),
})

setupListeners(store.dispatch); 
// Optional which enables refetching the data on certain events, such as refetchOnFocus and refetchOnReconnect

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch